<template lang="pug">
.content.front.in-page.front-landing-page.detail
    md-header(:icon="pcInfo.icon")
    Breadcrumb(:lstBreadcrumb="lstBreadcrumb")
    .box-lesson
        .container
            .col-md-3.col-sm-12.col-xs-12
              .box-info
                .avatar
                    img(:src="lesson.avatar" v-if="lesson.avatar && lesson.avatar !== null && lesson.avatar.length")
                    img(src="../../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
                .item-info
                    p.fullname {{$t("page.filter.teacher")}}:
                      span {{lesson.fullname}}
                    .jobs
                      router-link(:to="{ name: 'page_public', params: {subject_id: lesson.subject_id}}")
                        | {{$t("page.filter.subjects")}}:
                        span.subjects {{lesson.subject_name}}
                      router-link(:to="{ name: 'page_public', params: {grade_id: lesson.grade_id}}")
                        | {{$t("page.filter.grades")}}:
                        span.grades {{lesson.grade_name}}
                    .button-public-teacher
                      span(@click="publicTeacher(lesson.user_id)") {{$t("home.qa.view_teacher")}}
                .clearfix
            .col-md-9.col-sm-12.col-xs-12
              .box-detail-content
                .box-top-detail
                  .title {{lesson.name}}
                  .date {{$t("home.lesson.date")}} {{formatDate(lesson.updated_at)}}
                  .item-social
                    span
                      i.like.fa(@click="likeLesson(lesson.id)" v-if="!liked  || !this.$store.getters.user")
                        img(src="../../../../assets/images/home/ic_like_outline.svg")
                        | {{ numberWithCommas(lesson.count_like) }}
                      i.like.fa(@click="unLikeLesson(lesson.id)" v-else)
                        img(src="../../../../assets/images/home/ic_like.svg")
                        | {{ numberWithCommas(lesson.count_like) }}
                    span
                      i.fa
                        img(src="../../../../assets/images/home/ic_comment.svg")
                        | {{ numberWithCommas(lesson.count_comment) }}
                    span
                      i.fa
                        img(src="../../../../assets/images/home/ic_share.svg")
                        | {{ numberWithCommas(lesson.count_share) }}
                .box-middle-detail
                  .description(v-html="rawHtml(lesson.content)") {{lesson.files}}
                .box-bottom-detail(v-if="lesson.files && lesson.files !== null && lesson.files !== '[]'")
                  .related
                    span {{$t("home.lesson.attach")}}:
                  .related-item
                    .file-item(v-for="(file, index) in lesson.files" @click="download(file)")
                      img.fa-file(src="../../../../assets/images/faces/file-download-solid.svg")
                      span {{getFileName(file)}}
        .clearfix
</template>
<script>
import moment from 'moment-timezone'
import axios from 'axios'
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import store from '../../../../store'
import Breadcrumb from '../../Breadcrumb'
import MdNotification from '@/core/components/mdNotification'
import LoginModal from '@/components/Account/LoginModal'
import MdHeader from '@/components/Front/LandingPage/landing'
export default {
  components: {
    MdNotification,
    MdHeader,
    Breadcrumb
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      name: '',
      object_id: 0,
      isSucess: false,
      liked: false,
      lesson: [],
      lstBreadcrumb: [],
      pcInfo: []
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    rawHtml(html) {
      return html
    },
    onLessonSubject(paramSubject) {
      this.$router.push({name: 'page_lesson', params: {subject_id: paramSubject}})
    },
    onLessonGrade(paramGrade) {
      this.$router.push({name: 'page_lesson', params: {grade_id: paramGrade}})
    },
    publicTeacher(userID) {
      this.$router.push({name: 'account-view', params: {uid: userID}})
    },
    formatDate(date) {
      return moment(String(date)).format('hh:mm MM/DD/YYYY')
    },
    getFileName(file) {
      if (file.length) {
        let arrSplit = file.split('/')
        return arrSplit[arrSplit.length - 1]
      }
    },
    onBreadcrumb() {
      let lstPages = [
        {'path': this.getLinkMore(), 'title': this.$t('landing.title')},
        {'path': this.getLinkMore() + '/lesson', 'title': this.$t('home.lesson.title')},
        {'name': '', 'title': this.lesson.name}
      ]
      this.lstBreadcrumb.push(lstPages)
    },
    getLinkMore() {
      return '/' + this.$route.meta.parentName + '/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id
    },
    async getInfoPC(id) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_PC_WHERE_ANY),
          variables: {
            where: {id: {_eq: id}}
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
        if (data.private_community && data.private_community.length > 0) {
          this.pcInfo = data.private_community[0]
        }
      }
    },
    autoRefresh() {
      let variables = {
        id: this.$route.params.idDetail,
        type_lesson: 1
      }
      this.$apollo.query({
        query: gql(graphql.GET_LESSONS_DETAIL),
        variables: variables
      }).then((response) => {
        this.lesson = response.data.v_front_lesson[0]
        this.count_like = this.lesson.count_like
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    likeLesson(id) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit('setIsHomePage', true)
        let scrollTop = this.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        if (this.isMobile()) {
          try {
            this.$modal.show(LoginModal, {params: params}, {
              // width: '43%',
              height: 'auto',
              classes: ['col-6'],
              adaptive: true,
              resize: true,
              clickToClose: false
            })
          } catch (e) {}
        } else {
          this.$store.commit('setIsHomePage', false)
          this.$router.push({name: 'Login', params: params})
        }
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.LIKE_LESSONS_HOME),
            variables: {
              object_id: id,
              user_id: store.getters.user
            },
            update: (store, { data: { insert_likes_lesson } }) => {
              if (insert_likes_lesson.affected_rows) {
                this.liked = true
                this.lesson.count_like++
              }
              this.isSucess = false
            }
          }).catch((error) => {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0, this.$route.params, this.$route.query)
            }
          })
        }
      }
    },
    unLikeLesson(id) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit('setIsHomePage', true)
        let scrollTop = this.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        if (this.isMobile()) {
          try {
            this.$modal.show(LoginModal, {params: params}, {
              // width: '43%',
              height: 'auto',
              classes: ['col-6'],
              adaptive: true,
              resize: true,
              clickToClose: false
            })
          } catch (e) {}
        } else {
          this.$store.commit('setIsHomePage', false)
          this.$router.push({name: 'Login', params: params})
        }
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.UNLIKE_LESSONS_HOME),
            variables: {
              object_id: id,
              user_id: store.getters.user
            },
            update: (store, { data: { delete_likes_lesson } }) => {
              if (delete_likes_lesson.affected_rows) {
                this.liked = false
                if (this.lesson.count_like > 0) this.lesson.count_like--
              }
              this.isSucess = false
            }
          }).catch((error) => {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0, this.$route.params, this.$route.query)
            }
          })
        }
      }
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.getFileName(response.config.url))
      document.body.appendChild(link)
      link.click()
    },
    download(url) {
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response)
      })
      .catch(() => console.log('error occured'))
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id) && Number(this.$route.params.id) > 0) {
      await this.getInfoPC(Number(this.$route.params.id))
    }
    await this.autoRefresh()
    setTimeout(() => {
      this.onBreadcrumb()
    }, 100)
    this.object_id = this.$route.params.idDetail

    setTimeout(() => {
      if (this.$route.params.front_top !== undefined && this.$route.params.front_top) {
        window.scrollTo(0, this.$route.params.front_top)
      }
    }, 250)
    const {data} = await this.$apollo.query({
      query: gql(graphql.GET_LESSONS_LIKE_HOME),
      fetchPolicy: 'no-cache',
      variables: {
        object_id: this.object_id,
        user_id: store.getters.user
      }
    }).catch((error) => {
      if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
        this.$router.go(0, this.$route.params, this.$route.query)
      }
    })
    this.liked = data.likes_lesson.length > 0
    if (!this.$store.getters.isLoggedIn) {
      try {
        this.$modal.show(LoginModal, {}, {
          // width: '43%',
          height: 'auto',
          classes: ['col-6'],
          adaptive: true,
          resize: true,
          clickToClose: false
        })
      } catch (e) {}
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.content.front.in-page.detail{background: #FAFAFA;
    .box-lesson{
      .box-info{position: relative;background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border: 1px solid #EFEFEF;padding: 15px;margin-bottom: 40px;
        .avatar{width: 120px;height: 120px;border: 1px solid #707070;margin: 0 auto;display: flex;border-radius: 50%;overflow:hidden;
          img{justify-content: center;justify-items: center;vertical-align: middle;height: auto; max-width: 100%; margin: auto;}
        }
        .item-info{margin-top: 15px;
          .fullname{letter-spacing: 0px;color: #969FAD; font-size:13px;margin-bottom: 15px;
            span {display: block;letter-spacing: 0px;color: #4B2D15; font-size:15px; font-weight:bold;}
          }
          .jobs{display: table;width: 100%;margin-bottom: 20px;
            a{letter-spacing: 0px;color: #969FAD; font-size:13px;display: table-cell;width: 50%;
              span.subjects{cursor: pointer;font-size:15px;letter-spacing: 0px;color: #3A9F00;display: block;}
              span.grades{cursor: pointer;font-size:15px;letter-spacing: 0px;color: #9F6A28;display: block;}
            }
          }
          .button-public-teacher{cursor: pointer;
            span{background: #FFD311 0% 0% no-repeat padding-box;border-radius: 5px; height: 40px;display: block;line-height: 40px; text-align: center;color:#23180A; font-size:14px;}
          }
          span{text-align: left;}
        }
      }
      
      .box-detail-content{
        .box-top-detail{
          .title{letter-spacing: 0.6px; color: #4B2D15;font-weight: bold; font-size: 20px;margin-bottom: 15px;}
          .date{letter-spacing: 0px; color: #707070;font-size: 13px;}
          .item-social{margin-top:10px; display: table; width:50%;border-bottom: 1.5px solid #D9D3CF; padding-bottom: 15px;
            span { display: table-cell;  width: 33.33%;font-size:13px;
              i{color:#4B2D15; font-size:13px;
                  &:before{padding-right: 5px;}
                  img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
              }
              i.like{cursor: pointer;}
            }
          }
        }
        .box-middle-detail{letter-spacing: 0px;color: #4B2D15; font-size: 15px;margin: 15px 0;
          .description{
            table{max-width: 100%; height: auto; width: 100% !important;}
          }
        }
        .box-bottom-detail{margin-bottom: 40px;
          .related{letter-spacing: 0px;color: #23180A; font-size: 17px; font-weight: bold;margin-bottom: 15px;}
          .related-item{background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 5px; padding:0 20px;
            .file-item{cursor: pointer; padding: 15px 0;border-bottom: 1.5px solid #FAFAFA;
              .fa-file{width: 14px; height: 19px; max-width: 100%;color: #23180A;}
              span {letter-spacing: 0px; color: #4B2D15;font-size: 15px; padding-left: 15px;}
              &:last-child{border-bottom: 0 none;}
            }
          }
        }
      }
    }
}
@media (max-width: 1366px){
    .content.front.in-page{
        .box-lesson{
          .box-info{
            .button-public-teacher{
              span{font-size:12px !important;}
            }
          }
        }
    }
}
@media (max-width: 1024px){
    .content.front.in-page{
        .box-lesson{
          .button-public-teacher{
            span{font-size:12px !important;}
          }
        }
    }
}
@media (max-width: 991px){
    .content.front.in-page.detail{
        .box-lesson{
          .box-detail-content{
            .box-top-detail{
              .item-social{width: 100%;}
            }
          }
        }
    }
}
@media (max-width: 768px){
    .content.front.in-page{
        .box-lesson{
        }
    }
}
@media (max-width: 560px){
    .content.front.in-page{
        .box-lesson{
        }
    }
}
@media (max-width: 375px){
    .content.front.in-page{
        .box-lesson{
        }
    }
}
</style>




// WEBPACK FOOTER //
// detail.vue?abd4a7ae